import { useEffect, useState } from 'react';
import { Line } from 'react-konva';

// Bounding box of the product on the 800-px photo (transparent pixels or background colour of the corner).
export const useProductBox = image => {
  const [box, setBox] = useState(null);
  useEffect(() => {
    if (!image) return;
    try {
      const c = document.createElement('canvas'); c.width = c.height = 200; const g = c.getContext('2d');
      g.drawImage(image, 0, 0, 200, 200); const d = g.getImageData(0, 0, 200, 200).data, bg = [d[8], d[9], d[10]];
      let x0 = 200, y0 = 200, x1 = -1, y1 = -1;
      for (let y = 0; y < 200; y++) for (let x = 0; x < 200; x++) {
        const i = (y * 200 + x) * 4, on = d[i + 3] < 250 ? d[i + 3] > 24 : Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2]) > 54;
        if (on) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
      setBox(x1 > x0 && y1 > y0 ? { x: x0 * 4, y: y0 * 4, w: (x1 - x0 + 1) * 4, h: (y1 - y0 + 1) * 4 } : null);
    } catch { setBox(null); }
  }, [image]);
  return box;
};

export const guideLines = (product) => {
  const vx = [400], hy = [400];
  if (product) { vx.push(product.x, product.x + product.w, product.x + product.w / 2); hy.push(product.y, product.y + product.h, product.y + product.h / 2); }
  return { vx, hy };
};

// Snaps the zone position to the mm grid (centred on the product) and to guide lines within 6 px; the size stays as drawn.
export const snapZone = (z, { step, ppm, guides, origin }) => {
  let { x, y, w, h } = z;
  if (step && ppm > 0) {
    const g = step * ppm, ox = origin.x, oy = origin.y, r = v => Math.round(v / g) * g;
    x = ox + r(x + w / 2 - ox) - w / 2; y = oy + r(y + h / 2 - oy) - h / 2;
  }
  if (guides) {
    const near = (vals, lines) => { for (const [v, apply] of vals) for (const l of lines) if (Math.abs(v - l) < 6) return apply(l); return null; };
    const nx = near([[x + w / 2, l => l - w / 2], [x, l => l], [x + w, l => l - w]], guides.vx), ny = near([[y + h / 2, l => l - h / 2], [y, l => l], [y + h, l => l - h]], guides.hy);
    if (nx != null) x = nx; if (ny != null) y = ny;
  }
  return { ...z, x, y, w, h };
};

export const GuideLayer = ({ guides, step, ppm, origin, scale }) => {
  const lines = [];
  if (step && ppm > 0) {
    const g = step * ppm * (step === 1 && ppm < 3 ? 5 : 1);
    for (let v = origin.x % g; v <= 800; v += g) lines.push(<Line key={`gx${v}`} points={[v, 0, v, 800]} stroke="#56794233" strokeWidth={1 / scale} listening={false} />);
    for (let v = origin.y % g; v <= 800; v += g) lines.push(<Line key={`gy${v}`} points={[0, v, 800, v]} stroke="#56794233" strokeWidth={1 / scale} listening={false} />);
  }
  if (guides) {
    guides.vx.forEach((v, i) => lines.push(<Line key={`vx${i}`} points={[v, 0, v, 800]} stroke={i === 0 ? '#d9480f' : '#1c7ed6'} strokeWidth={1 / scale} dash={[6 / scale, 4 / scale]} opacity={.75} listening={false} />));
    guides.hy.forEach((v, i) => lines.push(<Line key={`hy${i}`} points={[0, v, 800, v]} stroke={i === 0 ? '#d9480f' : '#1c7ed6'} strokeWidth={1 / scale} dash={[6 / scale, 4 / scale]} opacity={.75} listening={false} />));
  }
  return lines;
};
